import { TicketStatusEnum } from '../apis/tournament';

/** Returns the translation key for the status */
export const ticketStatusTranslation = (status: TicketStatusEnum) => {
  const prefix = 'tournamentStatsTickets-';

  switch (status) {
    case TicketStatusEnum.PAID:
      return prefix + 'status-paid';
    case TicketStatusEnum.PROCESSING:
      return prefix + 'status-processing';
    case TicketStatusEnum.CANCELLED:
      return prefix + 'status-cancelled';
    case TicketStatusEnum.REFUNDED:
      return prefix + 'status-refunded';
    case TicketStatusEnum.TRANSFERRED:
      return prefix + 'status-transferred';
    case TicketStatusEnum.DISABLED:
      return prefix + 'status-disabled';
    case TicketStatusEnum.RESERVED:
      return prefix + 'status-reserved';
    default:
      return prefix + 'status-unknown';
  }
};
